export const TYPE_AGREEMENT = 1;
export const TYPE_PRIVACY = 2;
export const TYPE_CONTACTS = 3;
export const TYPE_RETURN = 4;
export const TYPE_PAYMENTS = 5;
export const TYPE_DELIVERY = 6;
